import { Button } from 'antd';
import styled from 'styled-components';
import { ReactSVG } from 'react-svg';

// export const Container = styled.div`
//     padding: 60px 0px;
//     gap: 30px;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     overflow: hidden;
//     overflow-y: auto;
//     @media screen and (max-height: 670px) {
//         padding: 10px 0px;
//         height: 65vh;
//     }
//     @media screen and (max-height: 570px) {
//         padding: 5px 0px;
//         height: 57vh;
//     }
//
// `;


export const OuterContainer = styled.div`
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    ::-webkit-scrollbar {
    display: none;
  }
`;

export const Container = styled.div`
    /* flex: 1; */
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
`;

export const StyledButton = styled(Button)`
    background-color: ${({ theme: { colors } }) => colors.mainColors.blue};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    font-size: 16px;
    color: white;
    border-radius: 10px !important;
    border: none;
    padding: 15px 10px;
    height: 100px;
    width: 100%;
    text-decoration: none !important;
    position: relative;
    span {
        color: white;
        text-align: center;
        text-decoration: none !important;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.2;
        margin-top: 8px;
    }
    a {
        text-decoration: none !important;
    }
    
    &:hover{
        border: 1px #0073ae solid;
        color: #0073ae !important;
        background-color: #185da9 !important;
    }
    &:disabled {
    background-color: #858585 !important;
    color: #fff !important;
    &:hover {
      background-color: #858585 !important;
      border: none !important;
    }
  }
`;
export const StyledDivLogout = styled.div`
    display: flex;
    background-color: #fab10b !important;
    flex-direction: row;
    align-items:center;
    border-radius: 10px !important;
    justify-content: center;
    padding: 0;
    height: 40px;
    color: white;
    text-decoration: none !important;
`;
export const StyledReactSVG = styled(ReactSVG)`
    color: white;
    margin-bottom: 5px;
    svg {
        height: 25px;
        width: 25px;
    }
`;
export const ButtonWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
    max-width: 600px;
    padding: 0 20px;
    @media screen and (max-height: 570px) {
      gap: 10px;
   }
   @media screen and (max-width: 480px) {
      gap: 15px;
      padding: 0 15px;
   }
`;

export const MainFooter = styled.div`
    width: 100%;
    height: 55px;
    background-color: #185da9;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const MainFooterDashboard = styled.div`
    padding-top: 120px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    @media screen and (max-height: 800px) {
        padding-top: 50px;
        padding-bottom: 15px;
    }
    @media screen and (max-height: 700px) {
        margin-top: 15px;
        padding-bottom: 15px;
        padding-top: 50px;
    }

`;

export const LogoutButton = styled(Button)`
    height: 40px;
    font-size: 18px;
    color: white;
    border-radius: 10px !important;
    border: none;
    padding: 0;
    width: 50%;
    span {
        color: white;
        text-align: center;
    }
`;

export const UserWrapper = styled.div`
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
`;
export const Name = styled.div`
    text-align: center;
    font-weight: 600;
    line-height: 12px;
    color:  ${({ theme: { colors } }) => colors.grayColors.gray};
    margin-bottom: 5px;
`;
export const Email = styled.div`
    text-align: center;
    color:  ${({ theme: { colors } }) => colors.grayColors.gray};
`;

export const Circle = styled.div`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #fab10b;
    position: absolute;
    top: -17px;
    right: -11px;
    text-align: center;
    font-size: 21px;
    color: white;
`;

export const CircleText = styled.div`
    text-align: center;
    font-size: 18px;
    padding-top: 3px;
`;

export const DeleteAccountLink = styled.span`
  color: #185da9;
  cursor: pointer;
  /* text-decoration: underline; */
  font-size: 16px;
  margin-top: 10px;
  align-self: center;
  &:hover {
    color: #185da9;
  }
`;

export const KorisnikWrapper = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 50px;
  @media only screen and (max-height: 700px) {
    margin-top: 30px;
    margin-bottom: 30px;
  }
  @media only screen and (max-height: 500px) {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;